import {  QUERY_DELETE_DELETE_EXCEPTION, QUERY_GET_EXCEPTION_LEVELS, QUERY_GET_EXCEPTIONS, QUERY_POST_CREATE_EXCEPTION, QUERY_PUT_UPDATE_EXCEPTION } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getExceptions = baseThunk(`exceptions/getExceptions`, QUERY_GET_EXCEPTIONS, "GET");
export const getExceptionLevels = baseThunk(`exceptions/getExceptionLevels`, QUERY_GET_EXCEPTION_LEVELS, "GET");

export const createException = baseThunk("exceptions/create", QUERY_POST_CREATE_EXCEPTION, "POST");
export const updateException = baseThunk("exceptions/update", QUERY_PUT_UPDATE_EXCEPTION, "PUT");
export const deleteException = baseThunk("exceptions/delete", QUERY_DELETE_DELETE_EXCEPTION, "DELETE")